import { getDayIndex } from '../../core/util';
import { Constants } from '../../common/constants';
import type { Types as IdunSoftTypes } from '../types';
import type { OutTypes } from './schedules';

export default (events: IdunSoftTypes.fromEvent[]): OutTypes.event[] => {
  return events
    .reduce<OutTypes.event[]>((acc, event, index) => {
      const ids = event['LektionID'];
      if (!ids)
        throw new Error('An event does not have a unique key');

      if (acc.some(x => x.ids == ids))
        throw new Error(`An event ID "${ids}" exists multiple times at indices ${ index } and ${ acc.findIndex(x => x.ids == ids) }`);

      if (!event['Lektionslängd'])
        throw new Error(`An event [${ ids }] does not have a duration`);

      const duration = (() => {
        try {
          return parseInt(event['Lektionslängd'].split('min')[0]);
        } catch {
          throw new Error('duration have wrong structure');
        }
      })();

      const teachers    = event['LärareID'] ? [...new Set(event['LärareID'].split(','))].map(to => ({ to })) : [];
      const groups      = event['GruppID' ] ? [event['GruppID']                        ].map(to => ({ to })) : [];
      const inLocations = event['RumID'   ] ? [event['RumID']                          ]                     : [];
      const locations   = inLocations.map(x => ({ locations: [x] as [string] }));

      const preferredDuration = parseInt(event.Lektionslängd); // ASSUMED TO BE OF THE FORMAT '40', IS THIS TRUE?

      const { start, end } = (() => {
        if (event.Starttid == null || event.VeckodagID == null) return { start: undefined, end: undefined };

        const day     = getDayIndex(event.VeckodagID);
        const hours   = Math.floor(event.Starttid * 24);
        const minutes = (event.Starttid * 24 - hours) * 60;

        const start = Constants.FIRST_DAY
          .clone()
          .add(day, 'days')
          .add(hours, 'hours')
          .add(minutes, 'minutes');
        const end = start
          .clone()
          .add(duration, 'minutes');

        return { start, end };
      })();

      const doc: OutTypes.event = {
        ids:    ids,
        course: event['Ämne'],
        preferredDuration,
        duration,
        teachers,
        groups,
        locations,
        inLocations,
        ...start && end && { start, end, parked: false }
      };
      return acc.concat(doc);
    }, []);
};